import { buildSearchStatus, SearchStatus } from '@coveo/headless';
import headlessEngine from './headlessEngine';

export const searchStatus: SearchStatus = buildSearchStatus(headlessEngine);
